import { createAction } from '@reduxjs/toolkit';
import { getActionTypePrefix } from '../functions';
import { AsyncRequestStateActions, CommonFeatures } from './types';

export const resetAsyncRequestState = createAction<string>(
  getActionTypePrefix(CommonFeatures.app, AsyncRequestStateActions.RESET),
);
